import React from "react"
import DatePicker from "react-datepicker"
import moment from "moment"

import SelectTags from "../../common/tags/SelectTags"

import {
    moderationStatuses,
    judgeModerationStatuses,
    sourceLanguages,
    publicationTypes
} from "../../../config/application-definitions"

const FeedKnowledgeListFilterForm = ({
    model,
    onEventChange,
    onValueChange,
    onTopicsSearch,
    onSourcesSearch
}) => (
    <form name="filterform">
        <div className="filter-block">
            <label htmlFor="title">Title</label>
            <input
                name="title"
                className="form-control"
                type="text"
                placeholder="Title"
                value={model.title}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="approved">Moderation Status</label>
            <select
                name="approved"
                className="form-control"
                value={model.approved}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {moderationStatuses.map(({ value, label }) => (
                    <option value={value} key={value}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="approved">Suggested Moderation Status</label>
            <select
                name="judge_moderation_status"
                className="form-control"
                value={model.judge_moderation_status}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {judgeModerationStatuses.map(({ value, label }) => (
                    <option value={value} key={value}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block filter-dates clearfix">
            <div className="form-group start-date-group">
                <label htmlFor="start_date">Start date</label>
                <DatePicker
                    name="start_date"
                    selectsStart
                    placeholderText={"e.g. " + moment().format("DD/MM/YYYY")}
                    className="form-control"
                    selected={model.start_date}
                    startDate={model.start_date}
                    endDate={model.end_date}
                    onChange={onValueChange("start_date")}
                />
            </div>
            <div className="form-group end-date-group">
                <label htmlFor="end_date">End date</label>
                <DatePicker
                    name="end_date"
                    selectsEnd
                    placeholderText={"e.g. " + moment().format("DD/MM/YYYY")}
                    className="form-control"
                    selected={model.end_date}
                    startDate={model.start_date}
                    endDate={model.end_date}
                    onChange={onValueChange("end_date")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="topics">Insight areas</label>
            <div className="filter-tags">
                <SelectTags
                    name="topics"
                    value={model.topics}
                    loadOptions={onTopicsSearch}
                    onChange={onValueChange("topics")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="sources">Sources</label>
            <div className="filter-tags">
                <SelectTags
                    name="sources"
                    labelKey="display_name"
                    value={model.sources}
                    loadOptions={onSourcesSearch}
                    onChange={onValueChange("sources")}
                />
            </div>
        </div>
        <div className="filter-block">
            <label htmlFor="language">Language</label>
            <select
                name="language"
                className="form-control"
                value={model.language}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {sourceLanguages.map(({ id, label }) => (
                    <option value={id} key={id}>
                        {label}
                    </option>
                ))}
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="has_source">Submission type</label>
            <select
                name="has_source"
                className="form-control"
                value={model.has_source}
                onChange={onEventChange}
            >
                <option value="">All</option>
                <option value="true" key="true">
                    Automatically submitted
                </option>
                <option value="false" key="false">
                    Manually submitted
                </option>
            </select>
        </div>
        <div className="filter-block">
            <label htmlFor="publisher">Publisher</label>
            <input
                type="text"
                name="publisher"
                className="form-control"
                placeholder="Publisher"
                value={model.publisher}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label>Publication type</label>
            <select
                className="form-control"
                name="source_publication_type"
                value={model.source_publication_type}
                onChange={onEventChange}
            >
                <option value="">All</option>
                {publicationTypes.map(type => (
                    <option value={type} key={type}>
                        {type}
                    </option>
                ))}
            </select>
        </div>
    </form>
)

export default FeedKnowledgeListFilterForm
